import { defineModule, getModule } from '@owlsdepartment/vuex-typed';

import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import state from './state';

const storeModule = defineModule({
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
});

export const {
	state: orderState,
	getters: orderGetters,
	mutations: orderMutations,
	actions: orderActions,
} = getModule(storeModule, 'order');
export default storeModule;
